@if (onboarding && !isFinishedOnboarding()) {
  <div class="onboarding-banner">
    <div class="onboarding-banner__header">
      <div>
        <h2 class="title">{{'onboarding.title'|transloco}}</h2>
        <p class="subtitle">{{'onboarding.subtitle'|transloco}}</p>
      </div>
      <div class="progress-ring">
        <svg width="48" height="48">
          <circle
            class="progress-ring__background"
            r="20"
            cx="24"
            cy="24"
            />
          <circle
            class="progress-ring__progress"
            r="20"
            cx="24"
            cy="24"
            [attr.stroke-dasharray]="circumference"
            [attr.stroke-dashoffset]="getStrokeOffset(onboarding.progress)"
            />
        </svg>
        <p>{{ onboarding.progress }}%</p>
      </div>
    </div>
    <div class="onboarding-banner__cards">
      <div class="onboarding-banner__card"
        [ngClass]="{' onboarding-banner__card--done': onboarding.publicProfile}"
        >
        <div>
          <div class="checkbox">
            <i class="fa-solid fa-check"></i>
          </div>
          <h3>{{'onboarding.step1.title'|transloco}}</h3>
          <p class="content">{{'onboarding.step1.content'|transloco}}</p>
        </div>
        <a class="button button--full-width"
          [routerLink]="['/manage/public-profile']"
          >
          <p>{{'onboarding.step1.cta'|transloco}}</p>
        </a>
      </div>
      <div class="onboarding-banner__card"
        [ngClass]="{' onboarding-banner__card--done': onboarding.services}"
        >
        <div>
          <div class="checkbox">
            <i class="fa-solid fa-check"></i>
          </div>
          <h3>{{'onboarding.step2.title'|transloco}}</h3>
          <p class="content">{{'onboarding.step2.content'|transloco}}</p>
        </div>
        <a class="button button--full-width"
          [routerLink]="['/manage/services']"
          >
          <p>{{'onboarding.step2.cta'|transloco}}</p>
        </a>
      </div>
      <div class="onboarding-banner__card"
        [ngClass]="{' onboarding-banner__card--done': onboarding.shared}"
        >
        <div>
          <div class="checkbox">
            <i class="fa-solid fa-check"></i>
          </div>
          <h3>{{'onboarding.step3.title'|transloco}}</h3>
          <p class="content">{{'onboarding.step3.content'|transloco}}</p>
        </div>
        <a class="button button--full-width"
          [routerLink]="['/photographer', photographer?.slug]"
          target="_blank"
          >
          <p>{{'onboarding.step3.cta'|transloco}}</p>
        </a>
      </div>
    </div>
  </div>
}
